import React, { useState } from "react"
import {
    Link
  } from 'react-router-dom'
import logo from '../Icons/AJGSoftwareW32.png';
import useScrollDirection from '../components/usescrolldirection'
import './NavBar.css'

export const NavBar = (props) => {

    const scrollDirection = useScrollDirection();

    return (

        <div className={`nav-class ${ scrollDirection === "down" ? "hide" : "show"}`} >
            <header id="nav-content" className="App-header" >
                <div class='row'>
                    <ul class="nav-links">
                        <li><a href="/"><img src={logo} alt="AJG Software" /></a></li>
                        <li><a href="/SoftwareDevelopment">Software Development</a></li>
                        <li><a href="/RoboticsAutomation">Robotics & Automation</a></li>
                        <li><a href="/Contact">Contact</a></li>
                        <li><a href="/About">About</a></li>
                    </ul>
                </div>
            </header>
        </div> 
    )
}

export default NavBar;
